


const getCurrentDate = () => {

    const date = new Date()

    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    const resultMonth = month.toString().length < 2 ? `0${month}`: month
    const resultDay = day.toString().length < 2 ? `0${day}`: day

    return `${resultDay}.${resultMonth}.${year}`
}

export default getCurrentDate